import { render, staticRenderFns } from "./ReceivablesTable.vue?vue&type=template&id=4c890aec"
import script from "./ReceivablesTable.vue?vue&type=script&lang=js"
export * from "./ReceivablesTable.vue?vue&type=script&lang=js"
import style0 from "./ReceivablesTable.vue?vue&type=style&index=0&id=4c890aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports